import { FormValues } from "@/models/proposalForm.model";
import { dateFormatter } from "@/utils/dateFormatter";
import { formatPhone } from "@/utils/formatPhone";
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Flex,
  Button,
  Heading,
  Icon,
  Text,
  Divider,
} from "@chakra-ui/react";
import { FormikProps, Field } from "formik";
import { MdPerson } from "react-icons/md";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

interface PersonalDataStepProps {
  formik: FormikProps<FormValues["personalData"]>;
  handleBack: () => void;
}

export default function PersonalDataStep({
  formik,
  handleBack,
}: PersonalDataStepProps) {
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const maskedValue = formatPhone(e.target.value);
    formik.setFieldValue("cellphone", maskedValue);
  };

  const handleBirthDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedDate = dateFormatter(e.target.value);
    formik.setFieldValue("birthDate", formattedDate);
  };
  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const upperCaseValue = e.target.value.toUpperCase();
    formik.setFieldValue("name", upperCaseValue);
  };

  const handleMotherNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const upperCaseValue = e.target.value.toUpperCase();
    formik.setFieldValue("motherName", upperCaseValue);
  };

  return (
    <Box
      bg="white"
      p={6}
      borderRadius="25px"
      boxShadow="md"
      borderColor="gray.200"
      maxW="800px"
      mx="auto"
      mt={10}
    >
      <Flex align="center" mb={4}>
        <Icon as={MdPerson} boxSize={8} color="gray.500" mr={2} />
        <Box>
          <Heading size="md" color="gray.700" fontFamily="Lexend Deca">
            Dados Pessoais
          </Heading>
          <Text color="blue.600" fontSize="sm" fontFamily="Lexend Deca">
            Precisamos de mais algumas informações para prosseguir
          </Text>
        </Box>
      </Flex>
      <Divider mb={6} />

      <Box mb={6}>
        <FormControl
          isInvalid={!!formik.errors?.name && !!formik.touched?.name}
        >
          <FormLabel fontFamily="Lexend Deca" htmlFor="name">
            Seu Nome Completo
          </FormLabel>
          <Field
            as={Input}
            fontFamily="Lexend Deca"
            id="name"
            name="name"
            placeholder="João da Silva"
            type="text"
            variant="flushed"
            w="100%"
            onChange={handleNameChange}
          />
          <FormErrorMessage>{formik.errors?.name}</FormErrorMessage>
        </FormControl>
      </Box>

      <Flex mb={6} gap="2rem">
        <FormControl
          isInvalid={!!formik.errors.birthDate && !!formik.touched.birthDate}
        >
          <FormLabel fontFamily="Lexend Deca" htmlFor="birthDate">
            Sua Data de Nascimento
          </FormLabel>
          <Field
            as={Input}
            fontFamily="Lexend Deca"
            id="birthDate"
            name="birthDate"
            placeholder="dd/mm/aaaa"
            type="tel"
            variant="flushed"
            onChange={handleBirthDateChange}
            value={formik.values.birthDate}
            w="100%"
          />
          <FormErrorMessage>{formik.errors.birthDate}</FormErrorMessage>
        </FormControl>
      </Flex>
      <Flex mb={6} gap="2rem">
        <FormControl
          isInvalid={!!formik.errors?.cellphone && !!formik.touched?.cellphone}
        >
          <FormLabel fontFamily="Lexend Deca" htmlFor="cellphone">
            Seu Celular
          </FormLabel>
          <Field
            fontFamily="Lexend Deca"
            as={Input}
            id="cellphone"
            name="cellphone"
            placeholder="(xx) xxxxx-xxxx"
            type="tel"
            variant="flushed"
            onChange={handlePhoneChange}
            w="100%"
          />
          <FormErrorMessage>{formik.errors?.cellphone}</FormErrorMessage>
        </FormControl>
      </Flex>

      <Box mb={6}>
        <FormControl
          isInvalid={
            !!formik.errors?.motherName && !!formik.touched?.motherName
          }
        >
          <FormLabel fontFamily="Lexend Deca" htmlFor="motherName">
            Nome Completo da sua Mãe
          </FormLabel>
          <Field
            as={Input}
            fontFamily="Lexend Deca"
            id="motherName"
            name="motherName"
            placeholder="Maria da Silva"
            type="text"
            variant="flushed"
            onChange={handleMotherNameChange}
            w="100%"
          />
          <FormErrorMessage>{formik.errors?.motherName}</FormErrorMessage>
        </FormControl>
      </Box>

      <Flex fontFamily="Lexend Deca" justifyContent="flex-end" gap={3} mt={6}>
        <Button
          leftIcon={<Icon as={IoIosArrowBack} />}
          colorScheme="secondary"
          variant="outline"
          onClick={handleBack}
        >
          Voltar
        </Button>
        <Button
          rightIcon={<Icon as={IoIosArrowForward} />}
          colorScheme="primary"
          onClick={formik.submitForm}
        >
          Prosseguir
        </Button>
      </Flex>
    </Box>
  );
}
